import { render, staticRenderFns } from "./customer-info.vue?vue&type=template&id=f77687d2&scoped=true&"
import script from "./customer-info.vue?vue&type=script&lang=js&"
export * from "./customer-info.vue?vue&type=script&lang=js&"
import style0 from "./customer-info.vue?vue&type=style&index=0&id=f77687d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77687d2",
  null
  
)

export default component.exports